<template>
  <div class="geolocation-component">
    <v-dialog content-class="expand overlay-dialog geolocation-dialog" persistent v-model="show" height="90%">
      <template v-if="checkType()">
        <div class="header" :class="{'simple':(message.errorCode === 612 || errorMsgLocalStorage === '612')}">
          <v-layout align-center>
            <v-flex>
              <h1 class="">{{ $t('Geolocation.ErrorMessage.Header') }}</h1>

            </v-flex>
          </v-layout>
        </div>
        <div class="geo-content">
          <v-layout align-center>
            <v-flex>
              <div class="troubleshooter-container">
                <v-card @scroll="handleScroll()" class="troubleshooter-msg" v-if="message.errorCode && (message.errorCode !== 612 && message.errorCode !== 615)">
                  <div v-for="(item, index) in geocomplyTroubleshooter" :key="index"> <br>
                    <p> {{ item.Message }} <br>
                    <span v-if="item.HelpLink">Help:
                      <a target="_blank" :href="item.HelpLink"> {{ item.HelpLink }}</a>
                    </span>
                    <i v-if="index !== geocomplyTroubleshooter.length - 1" class="space-btw"></i>
                    </p>
                  </div>
                </v-card>
              </div>
              <div v-if="message.errorCode === 612 || message.errorCode === 615">
                <!-- <a class="gc-link" @click.stop="pluginDownload()">DOWNLOAD GEOLOCATION PLUGIN TO BET</a> -->
                <p v-if="message.errorCode === 615" style="margin-top: 10px"><i>{{ $t('Geolocation.ErrorCode.Note') }}</i></p>
              </div>
              <p v-if="message.errorCode === 612" :class="{'simple': message.errorCode === 612}">{{ $t('Geolocation.ErrorCode.'+ geolocationProvider + '.' + message.errorCode) }}</p>
              <i v-if="message.errorCode === 612" class="space-btw"></i>
              <p v-if="message.errorCode === 612" class="geo-suggestion" :class="{'simple': message.errorCode === 612}">{{ $t('Geolocation.ErrorCode.' + geolocationProvider + '.suggestion') }}</p>
              <i v-if="message.errorCode === 612" class="space-btw"></i>
              <p class="simple" v-if="message.errorCode === 612" v-html="$t('Contact.Support')"></p>
            </v-flex>
          </v-layout>
        </div>
        <!-- -->
        <div class="geo-content">
            <div class="buttons">
              <v-btn v-if="message.errorCode === 612 || message.errorCode === 615" block @click.stop="pluginDownload()" class="download-btn">
                <span>{{ $t('Geolocation.ErrorMessage.DownloadNow') }}</span>
              </v-btn>
              <v-btn v-if="retry || message.errorCode === 612" block @click.stop="geolocateAgain()" class="try-again-btn">
                <span class="gc-link">{{ $t('Geolocation.ErrorMessage.TryAgain') }}</span>
              </v-btn>
              <v-btn v-if="message.errorCode !== 612" block @click.stop="closeDialog()" class="okay-btn">
                <span class="gc-link">{{ $t('Geolocation.ErrorMessage.OK') }}</span>
              </v-btn>
              <v-btn v-if="message.errorCode === 612" block @click.stop="closeDialog()" class="maybe-later-btn">
                <span class="gc-link">{{ $t('Geolocation.ErrorMessage.MaybeLater') }}</span>
              </v-btn>
            </div>
          </div>
      </template>
      <template v-else-if="message && message.errorCode === 'BROWSER_LOCATION_DENIED' && message.errorMessage">
        <div class="header simple">
          <v-layout align-center>
            <v-flex>
              <h1 class="">{{ $t('Geolocation.ErrorMessage.Browser.Header') }}</h1>
            </v-flex>
          </v-layout>
        </div>
        <div class="geo-content">
          <v-layout align-center>
            <v-flex>
              <p v-html="$t('Geolocation.Browser.Denied.Description')"></p>
              <i class="space-btw"></i>
              <div>
                <p style="margin-top: 10px" class="simple" v-html="$t('Geolocation.Browser.Denied.' + message.browser)"></p>
              </div>
            </v-flex>
          </v-layout>
        </div>
        <div class="geo-content">
          <div class="buttons">
            <v-btn block @click.stop="geolocateAgain()" class="try-again-btn">
              <span class="gc-link">{{ $t('Geolocation.ErrorMessage.TryAgain') }}</span>
            </v-btn>
            <v-btn block @click.stop="closeDialog()" class="okay-btn">
              <span class="gc-link">{{ $t('Geolocation.ErrorMessage.OK') }}</span>
            </v-btn>
          </div>
        </div>
      </template>
      <template v-else-if="message && message.errorCode && message.errorMessage">
        <div class="geo-content">
          <v-layout align-center>
            <v-flex>
              <div>
                <p style="margin-top: 10px" class="simple">{{ $t('Geolocation.ErrorCode.Label', { errorCode: message.errorCode }) }}</p>
                <p style="margin-top: 10px" class="simple">{{ message.errorMessage }}</p>
              </div>
              <p class="simple" v-html="$t('Contact.Support')"></p>
            </v-flex>
          </v-layout>
        </div>
        <div class="geo-content">
          <div class="buttons">
            <v-btn block @click.stop="closeDialog()" class="okay-btn">
              <span class="gc-link">{{ $t('Geolocation.ErrorMessage.OK') }}</span>
            </v-btn>
          </div>
        </div>
      </template>
      <template v-else>
        <div class="geo-content">
          <v-layout align-center>
            <v-flex>
              <div>
                <p style="margin-top: 10px" class="simple">{{ $t('Geolocation.ErrorCode.NotFound') }}</p>
                <p style="margin-top: 10px" class="simple">{{ $t('Geolocation.ErrorMessage.NotFound') }}</p>
              </div>
              <p class="simple" v-html="$t('Contact.Support')"></p>
            </v-flex>
          </v-layout>
        </div>
        <div class="geo-content">
          <div class="buttons">
            <v-btn block @click.stop="closeDialog()" class="okay-btn">
              <span class="gc-link">{{ $t('Geolocation.ErrorMessage.OK') }}</span>
            </v-btn>
          </div>
        </div>
      </template>
    </v-dialog>
  </div>
</template>
<script>
  import store from '@/store'
  import Screen from '@/components/mixins/Screen'
  import airBridge from '@/components/mixins/airBridge'
  import mobileBridge from '@/library/mobileBridge'
  import config from '@/config'
  import GeolocationManager from '@/library/geolocation/services/geolocationManager'
  // import moment from 'moment'

  export default {
    name: 'geolocation-component',

    mixins: [
      Screen,
      airBridge
    ],

    data () {
      return {
        show: true,
        interval: {},
        errorMsgLocalStorage: false,
        dialogRadius: ['mobileGeoResponse', 612],
        retry: true,
        hasScrolledToBottom: false,
        geoManager: null
      }
    },

    computed: {
      config () {
        return config
      },
      geoErrorMsgLocalStorage () {
        let errorCode = localStorage.getItem('geoError')
        console.log(errorCode)
        if (errorCode === 612 || errorCode === '612') {
          let newErrorCode = this.message.errorCode = parseInt(errorCode)
          return newErrorCode
        }
        return false
      },
      message () {
        return store.getters['overlayState/getGeolocationMessage']
      },
      state () {
        return window.ctsautoconf.STATE
      },
      externalUrls () {
        return config.externalUrls
      },
      externalWalletProvider () {
        return config.app.autoconf.WALLET_PROVIDER
      },
      walletParams () {
        return config.walletParams
      },
      geocomplyTroubleshooter () {
        if (store.getters['getGeocomplyTroubleshooter']) {
          return store.getters['getGeocomplyTroubleshooter']
        }
        return []
      },
      managerInstance () {
        if (!this.geoManager) this.geoManager = GeolocationManager.getInstance(config.app.autoconf.GEOLOCATION.PROVIDER, this.$geolocationDebug)
        return this.geoManager
      },
      geolocationProvider () {
        return config.app.autoconf.GEOLOCATION.PROVIDER
      }
    },

    methods: {
      closeDialog () {
        this.show = !this.show
        store.dispatch('overlayState/deactivateGeolocationDialog')
      },
      pluginDownload () {
        this.managerInstance.downloadPlugin()
      },
      geolocateAgain () {
        let userID = localStorage.customer
        let sessionId = null
        let errorCode = 'verify'
        store.commit('overlayState/setGeolocationMessage', { errorCode })
        localStorage.setItem('geoError', false)
        this.managerInstance.initGeolocation(userID, sessionId)
        this.closeDialog()
      },
      formatUrl (url) {
        return url.substring(0, url.lastIndexOf('.com') + 4)
      },
      goTo (param) {
        var reason
        if (this.externalWalletProvider === 'GAN') {
          if (param === 'ERROR.LOCATION_SERVICES_DISABLE') {
            reason = 'phone_settings'
          } else {
            reason = 'geo_recheck'
          }
          this.airBridgeRequest(reason, { 'state': window.ctsautoconf.STATE.toLowerCase() })
          this.closeDialog()
        }
        if (this.externalWalletProvider === 'FD') {
          if (param === 'singleMobileError') {
            let action = this.message.data.errors.buttonAction
            console.log('action')
            console.log(action)
            /* eslint no-eval: 0 */
            eval(action)
          }
          if (param === 'mobileGeolocationError') {
            mobileBridge.geolocateUser('Retry Geolocation')
          }
          this.closeDialog()
        }
      },
      checkType () {
        if (this.message.errorCode === 'softGeolocation' ||
        this.message.errorCode === 'softGeolocationRedirect' ||
        this.message.errorCode === 'hardGeolocationRedirect' ||
        ((this.message.errorCode === 999) ||
        (this.message.errorCode === 612 || this.geoErrorMsgLocalStorage === 612) ||
        this.message.errorCode === 615)
        ) {
          return true
        }
        return false
      },
      countReached () {
        if (this.screenHeight < 481) { // small device / IPhone 4
          return {bottom: '-5px'}
        } else if (this.screenHeight > 481 && this.screenHeight < 569) { // Iphone 5/SE
          return {bottom: '-7px'}
        } else {
          return {bottom: '-20px'}
        }
      },
      allowRetry () {
        const isRetry = this.geocomplyTroubleshooter
        const result = isRetry.find(el => !el.CanRetry)
        if (result) {
          this.retry = false
        }
      },
      handleScroll () {
        let e = window.event.target
        if ((e.offsetHeight + e.scrollTop) >= e.scrollHeight) {
          this.hasScrolledToBottom = true
        } else {
          this.hasScrolledToBottom = false
        }
      }
    },

    created () {
      this.allowRetry()
      window.addEventListener('scroll', this.handleScroll)
    },
    mounted () {
      if (this.dialogRadius.includes(this.message.errorCode) || this.dialogRadius.includes(this.message.messageType)) {
        document.getElementsByClassName('geolocation-dialog')[0].style.borderRadius = '4px'
      }
    }
  }
</script>
<style lang="stylus" scoped>
@import '~@/css/config';
.v-dialog:not(.dialog--fullscreen) {
  width: 421px;
}
.geolocation-dialog {
  background: transparent;
  padding: 0px;
  border-radius: 4px;

  .header {
    padding: 15px 15px 10px 15px;
    text-align: center
  }

  h1 {
    margin: 0
    text-transform: uppercase
    font-size: 25px
    letter-spacing: 0.05em
    line-height: 35px
    color: #fff
  }

  .geo-content {
    line-height: 20px
    text-align: left
    color: #818e95
    padding: 0px 30px
    margin-top 10px
    font-size: 14px
    .geo-suggestion {
      margin-top: 10px;
      color: #e24447
      text-align: left
    }

    .buttons {
      padding-bottom: 20px;
      margin-top 0
    }
  }
}

.softGeolocationLinks
  .state-wrapper
    display flex
    padding-bottom 16px
    .state-link
      display flex
      flex-grow 6
      text-transform uppercase
      color: #1493ff

.softGeolocationRedirect
  color: #1f375b !important
.nothx
  text-align: center
  padding-top: 10px
  a
    color: #1f375b
    font-size: 14px
    line-height: 16px

/* mobile response for failed geolocation */

.geo-content.mobile-response
  padding: 0 16px 16px 16px
  position: relative
  .content-wrapper
    flex-wrap: wrap;
    overflow-y: auto;
    overflow-x: hidden;
    overscroll-behavior: contain;
    margin-bottom: 5px
    .header
      font-weight: normal
      text-align: center
      padding: 26px 0 0 0
      color: #445058
      h1
        font-weight: normal
        color: #1f375b
        text-transform: inherit
        font-size: 18px
        font-style: normal
        font-stretch: normal
        line-height: normal
        letter-spacing: normal
      p
        line-height: 22px
        font-size: 14px

    .inner-content
      color: #445058
      .error-body
        width: 100%
        .v-card
          border: 1px solid #da812d
          border-radius: 4px
          margin: 15px 0
          box-shadow: none
          font-size: 14px
          font-style: normal
          font-stretch: normal
          line-height: normal
          letter-spacing: normal
          .card-title
            line-height: 16px
            padding: 8px 12px
            background-color: #fcf3ea
            border-bottom: 1px solid #da812d
            span
              color: #445058

          .card-content
            padding: 8px 10px
            .error-cont
              margin-bottom: 5px
  .bottom-gradient
    display: block
    height: 40px
    position: relative
    top: -45px
    background: -webkit-linear-gradient(rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 1) 100%)
    background-image: -moz-linear-gradient(rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 1) 100%)
    background-image: -o-linear-gradient(rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 1) 100%)
    background-image: linear-gradient(rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 1) 100%)
    background-image: -ms-linear-gradient(rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 1) 100%)
  .buttons
    padding: 0
    height: 100px
    margin: 0px
    button
      height: 44px
      border-radius: 4px
  .multi-error
    display: flex
    position: absolute
    width: 100%
    margin-top: 0px
    padding: 0 16px 10px 16px
    bottom: 0
    left: 0
    flex-direction: row-reverse
    border-top: 1px solid #cfd6db
    .btn
      flex-grow: 1
      margin-top: 20px

  .single-error
    .singleCountReached
      text-align: center
      margin: 0px
      padding: 6px
      font-size: 1rem
    .singleCountReached.ERROR.LOCATION_SERVICES_DISABLE
      margin-top:0px
  .button-disabled
    height: 110px

  .multiCountReached
    text-align: center
    position: absolute
    width: 90%
    margin: 0px
    bottom: 8px
    font-size: 1rem
  .1plus
    bottom: -24px !important

.geo-content.mobile-response.single-error-dialog
  .content-wrapper
    flex-wrap: wrap
    overflow-y: scroll
    overflow-x: hidden
    .inner-content
      margin: 11px
      p
        font-stretch: normal
        line-height: 22px
        letter-spacing: normal
        text-align: center

::-webkit-scrollbar
  width: 0px
  background: transparent

.ServiceDisabled p
  margin-bottom: 0px !important
  text-align: left !important

.os-ios
  @media only screen and (min-device-width: 320px) and (max-device-width: 480px) and (-webkit-device-pixel-ratio: 2) and (device-aspect-ratio: 2/3)
    .singleCountReached
      font-size: 1rem

// mobile app redirect
.mobileAppRedirect
  font-size: 14px
  text-align: center
  letter-spacing: normal
  font-style: normal
  font-stretch: normal
  line-height: normal
  margin:16px
  .header
    padding: 10px 0 10px 0
    h1
      color: #1f375b
      font-size: 18px
      text-align: center
      font-weight: normal
      text-transform: capitalize
  .inner-content
    margin: 0
    p
      margin: 0
  .buttons
    margin: 24px 0 0 0
    span
      color: #ffffff
      font-weight: normal

h1.simple
  font-size 18px
  font-weight bold
  color #1f375b
  text-align center
  text-transform uppercase
.close
  position relative
  margin-right -10px
  color #cfd6db
  vertical-align middle
  display flex
  cursor pointer
  .material-icons
    font-size 18px
.gc-postpone
  color #1493ff
  font-size 14px
  font-weight bold
  height 30px
  padding 16px 8px
  cursor pointer
  text-align center
p.simple
  color #445058
  text-align left
  margin 10px 0
.geo-suggestion.simple
  color #445058 !important
  text-align center
  margin-top 0px
.header.simple
  padding: 20px 0

.inner-content.fd
  height 110px
  border-radius 4px
  padding 5px
  padding-bottom 25px
  cursor pointer
  max-height 100%
  flex-wrap: wrap
  overflow-y: scroll
  scroll-behavior smooth
  overflow auto
  h3
    margin-bottom 5px !important
  .card-content
    margin-bottom 15px
  .card-title
    color #445058

/*after design update and message setup, need to be adapted*/
.geolocation-dialog .geo-content .geo-suggestion.clear
  margin-top: 10px !important
.troubleshooter-msg
  display flex
  flex-direction column
  max-height 210px
  overflow scroll
.troubleshooter-container
  position relative
  .space-btw
    display flex
    justify-content center
    margin-top: 15px
    height: 3px
    background: #ccc
    // background: -webkit-gradient(linear, 0 0, 100% 0, from(white), to(white), color-stop(50%, black))
.space-btw
    display flex
    justify-content center
    margin-top: 15px
    height: 3px
    background: #ccc
</style>



// WEBPACK FOOTER //
// src/components/common/GeolocationTroubleshooter.vue